import React from "react";
import { TextField, MenuItem, FormControl, FormLabel } from "@mui/material";

const SelectInput = ({
  id,
  label,
  name,
  value,
  onChange,
  required,
  helperText,
  options = [],
  disabled = false,
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      sx={{ mb: 2 }}
      disabled={disabled}
    >
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <TextField
        id={id}
        name={name}
        select
        value={value}
        onChange={onChange}
        helperText={helperText}
        disabled={disabled}
      >
        {options.length === 0 ? (
          <MenuItem value="" disabled>
            No option available
          </MenuItem>
        ) : (
          options.map((opt, index) => (
            <MenuItem key={index} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))
        )}
      </TextField>
    </FormControl>
  );
};

export default SelectInput;
